const getMenuItemFromId = (id, menu) => {
  const items = menu.map(({ categoryItems }) => categoryItems).flat();
  const item = items.find(({ itemId }) => itemId === id);

  return item;
};

export default getMenuItemFromId;
